module.exports = __webpack_public_path__ + "static/media/18ECA38.afd9adc0.jpg";